var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"discussion-text py-4"},[(_vm.data.card_question.length)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.data.card_question[0].question)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }